import {
  storeGES,
  editGES,
  indexEmployeesGES,
} from "@/services/health-tracker/ges/service";

const state = () => ({
  /**
   * Empleados
   */
  employees: {
    data: [],
    links: {},
    meta: {},
  },
  processingEmployees: false,

  /**
   * GES
   */
  ges: {
    name: "",
    code_type_ges: "",
    sve_id: 0,
    employees: [],
  },
  processing: false,
  errors: null,
  isSuccess: false,
  usersNotAdded: null
});

const mutations = {
  /**
   * Empelados
   */
  SET_EMPLOYEES(state, employees = { data: [], links: {}, meta: {} }) {
    state.employees.data = employees.data;
    state.employees.links = employees.links;
    state.employees.meta = employees.meta;
  },

  SET_PROCESSING_EMPLOYEES(state, value = true) {
    state.processingEmployees = value;
  },

  /**
   * GES
   */
  SET_PROCESSING(state, value = true) {
    state.processing = value;
  },
  SET_ERROR(state, errors) {
    state.errors = errors;
  },
  SET_IS_SUCCESS(state, value = true) {
    state.isSuccess = value;
  },
  SET_USERS_NOT_ADDED(state, usersNotAdded) {
    state.usersNotAdded = usersNotAdded;
  },
  SET_EMPLOYEES_SELECT(state, employees) {
    state.employees.data = employees;
  }
};

const actions = {
  /**
   * Empleados
   */
  async indexEmployee({ commit }, { id = 0, values = {} }) {
    commit("SET_PROCESSING_EMPLOYEES");
    commit("SET_EMPLOYEES", { data: [], links: {}, meta: {} });
    const {
      data: { data, links, meta },
      error,
    } = await indexEmployeesGES(id, values).finally(() =>
      commit("SET_PROCESSING_EMPLOYEES", false)
    );
    if (error) {
      return alert(
        `/¡Lo sentimos!, ocurrio un error cargando los empleados. ${error.detail}`
      );
    }
    
    const newData = data.map((employee) => {
      return {
        ...employee,
        isSelected: false,
      };
    });
    commit("SET_EMPLOYEES", { data: newData, links, meta });
  },

  updateSelectedEmployees({ commit }, employees) {
    commit("SET_EMPLOYEES_SELECT", employees);
  },

  updateStateEmployee({ commit }) {
    commit("SET_EMPLOYEES", { data: [], links: {}, meta: {} });
  },
  /**
   * GES
   */
  async store(
    { commit },
    values = { name: "", code_type_ges: "", sve_id: 0, employees: [] }
  ) {
    const isEmpty = (arr) => !Array.isArray(arr) || arr.length === 0;
    if (isEmpty(values.employees)) {
      delete values.employees;
    }
    commit("SET_PROCESSING");
    commit("SET_ERROR", null);
    commit("SET_IS_SUCCESS", false);
    try {
      const { data } = await storeGES(values);
      if (data?.usersNotAdded?.length === 0) data.usersNotAdded = null;
      commit("SET_USERS_NOT_ADDED", data?.usersNotAdded);
      commit("SET_IS_SUCCESS");
    } catch (error) {
        commit("SET_ERROR", error);
    } finally {
      commit("SET_PROCESSING", false);
    }
  },

  async editGes(
    { commit },
    values,
  ) {
    const isEmpty = (arr) => !Array.isArray(arr) || arr.length === 0;
    if (isEmpty(values.employees)) {
      delete values.employees;
    }
    commit("SET_PROCESSING");
    commit("SET_ERROR", null);
    commit("SET_IS_SUCCESS", false);
    try {
      const { data } =await editGES(values?.id, values?.formData);
      if (data?.usersNotAdded?.length === 0) data.usersNotAdded = null;

      commit("SET_USERS_NOT_ADDED", data?.usersNotAdded);
      commit("SET_IS_SUCCESS");
    } catch (error) {
      commit("SET_ERROR", error);
    } finally {
      commit("SET_PROCESSING", false);
    }
  },
};

const getters = {
  /**
   * Emepleados
   */
  getEmployeesGES: (state) => {
    return state.employees;
  },
  getProcessingEmployees: (state) => {
    return state.processingEmployees;
  },

  /**
   * GES
   */
  getProcessing: (state) => {
    return state.processing;
  },
  getErrors: (state) => {
    return state.errors;
  },
  getIsSuccess: (state) => {
    return state.isSuccess;
  },
  getUsersNotAdded: (state) => state.usersNotAdded
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
